import { Component, Input } from '@angular/core';
import { ChartConfiguration, ChartDataset, ChartOptions } from 'chart.js';

@Component({
  selector: 'doughnut-chart',
  templateUrl: './doughnut-chart.component.html',
  styleUrls: ['./doughnut-chart.component.scss'],
})
export class DoughnutChartComponent {

  readonly type: ChartConfiguration<'doughnut'>['type'] = 'doughnut';

  options: ChartOptions<'doughnut'> = {
    plugins: {
      title: {
        display: false,
        position: 'top',
        text: '',
      },
      legend: {
        display: true,
        position: 'right'
      },
      tooltip: {
        enabled: true
      }
    },
    responsive: true,
    maintainAspectRatio: false,
    animation: {
      animateScale: true,
      animateRotate: true
    },
  };

  @Input() height = 250;

  @Input() set data(data: number[] | undefined) {
    if (data) {
      this.dataset = [{
        data,
      }];
      this.chartData = data;
    }
  };

  @Input() set title(title: string | undefined) {
    if (title) {
      if (!this.options.plugins) this.options.plugins = {};
      if (!this.options.plugins.title) this.options.plugins.title = {};

      this.options.plugins.title.text = title;
    }
  };

  @Input() set inlineTitle(value: boolean) {
    if (value != undefined) {
      if (!this.options.plugins) this.options.plugins = {};
      if (!this.options.plugins.title) this.options.plugins.title = {};

      this.options.plugins.title.display = value;
      if(value) this.options.plugins.title.position = 'left';
    }
  };

  @Input() noContentTitle = $localize`:Stats|Stats missing title@@stats-missing-title:No statistical data available at the moment`;
  @Input() noContentDetails = '';

  @Input() labels: string[] = [];

  dataset: ChartDataset<'doughnut'>[] = [];
  chartData?: number[];

}
